import { Component } from "react";
import Uppy from "@uppy/core";
import { DashboardModal } from "@uppy/react";
import Transloadit from "@uppy/transloadit";
import GoogleDrive from "@uppy/google-drive";
import Instagram from "@uppy/instagram";
import Url from "@uppy/url";
import Webcam from "@uppy/webcam";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import { TOAST_ERROR } from "../../../../../utils";
import {
  UPPY_AWS_KEY,
  UPPY_AWS_SECRET_KEY,
  UPPY_BUCKET,
  UPPY_BUCKET_URL,
  UPPY_CAMPAION_URL,
  UPPY_KEY,
} from "../../../../../actions/constant";

const uppyKey = UPPY_KEY;
const uppyBucket = UPPY_BUCKET;
const uppyAwsKey = UPPY_AWS_KEY;
const uppyAwsSecret = UPPY_AWS_SECRET_KEY;
const companionUrl = UPPY_CAMPAION_URL;

class UploadStudio extends Component {
  constructor(props) {
    super(props);

    this.uppyPostEdit = new Uppy({
      debug: true,
      autoProceed: true,
      restrictions: {
        maxFileSize: 6000000,
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        allowedFileTypes: ["image/*"],
      },
      onBeforeUpload: (files) => {},
    })
      .use(Transloadit, {
        target: "#a",
        params: {
          auth: {
            key: uppyKey,
          },
          steps: {
            store: {
              robot: "/wasabi/store",
              bucket_region: "us-west-1",
              bucket: uppyBucket,
              key: uppyAwsKey,
              secret: uppyAwsSecret,
              path: 'media/tmpimages/${file.id}.${file.ext}',
            },
          },
        },
        waitForEncoding: true,
      })
      .use(Instagram, { target: Uppy.Dashboard, companionUrl: companionUrl })
      .use(GoogleDrive, { target: Uppy.Dashboard, companionUrl: companionUrl })
      .use(Url, { target: Uppy.Dashboard, companionUrl: companionUrl })
      .use(Webcam, { target: Uppy.Dashboard, companionUrl: companionUrl })

      .on("restriction-failed", (file, error) => {
        let fileType = file.type.split("/");

        if (fileType[0] != "image") {
          TOAST_ERROR("You can only upload Image/Video file");
          return false;
        }

        if (file.size > 6000000) {
          TOAST_ERROR("Maximum allowed size of 5 MB");
          return false;
        }
      });

    this.onClickToOpen = this.onClickToOpen.bind(this);
    this.onClickToClose = this.onClickToClose.bind(this);
  }

  state = {
    filename: null,
    modalOpen: false,
    mediaTyp: null,
    updateFile: 0,
    thumb_file: null,
    selected: "",
    thumbPic: null,
    thumbName: null,
  };

  onClickToOpen = () => {   
    this.setState({ modalOpen: true });
  };

  onClickToClose = () => {  
    this.uppyPostEdit.cancelAll();
    this.setState({ modalOpen: false });
  };

  componentWillUnmount() {
    this.uppyPostEdit.cancelAll();
    this.uppyPostEdit.close({ reason: "unmount" });
    this.setState({ modalOpen: false });
  }

  componentDidMount() {

    const vl= this;
    this.uppyPostEdit.on("transloadit:result", (stepName, result) => {
      const fileKeys = Object.keys(result);
      const { updateImage } = this.props;
      updateImage(result);
      this.setState({ thumbPic: `${UPPY_BUCKET_URL}media/tmpimages/${result.id}.${result.ext}`, thumbName: result.name });
    });

    window.$(".uppy-Dashboard-close").click(function(){
         vl.props.removeImage();
    });
  }


  render() {
    const { thumbPic, thumbName, modalOpen } = this.state;
    const { updateImage, removeImage, picture } = this.props;

    return (
      <div className="uppy">
        {!picture ? (
          <div className="uppy_upload_btn" onClick={() => this.onClickToOpen()}>
            Upload Background Image
          </div>
        ) : (
          <div className="uppy-thumbnails">
            <div className="uppy-thumbnail-container position-relative text-end">
              <div className="uppy-thumbnail pe-4">
                <img className='img-thumbnail' src={picture} style={{ width: "100%",height:'140px', objectFit : 'cover' }} />
              </div>
              {/* <span className="uppy-thumbnail-label">{thumbName}</span> */}
              <span
                className="uppy-remove-thumbnail  cursor-pointer position-absolute top-0 end-0"
                onClick={() => {
                  removeImage();
                  //this.setState({ thumbPic: null });
                }}
              >
                <i className="fa fa-close"></i>
              </span>
            </div>
          </div>
        )}

        {/* {modalOpen ? ( */}

        <DashboardModal
          animateOpenClose={true}
          proudlyDisplayPoweredByUppy={false}
          inline={false}
          showProgressDetails={true}
          height={750}
          browserBackButtonClose={true}
          showRemoveButtonAfterComplete={false}
          uppy={this.uppyPostEdit}
          open={modalOpen}
          onRequestCloseModal={this.onClickToClose}
          closeAfterFinish={true}
          doneButtonHandler={this.doneButtonHandler}
          plugins={["Instagram", "GoogleDrive", "Url", "Webcam"]}
        />
        {/* ) : null} */}
      </div>
    );
  }
}

export default UploadStudio;
